import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    CircularProgress,
    List,
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
    Checkbox,
    Typography,
    IconButton,
    Tooltip,
    Alert
} from '@mui/material';
import {
    Add as AddIcon,
    Visibility as ViewIcon,
    Edit as EditIcon,
    Delete as DeleteIcon
} from '@mui/icons-material';

export default function GroupSelectionDialog({
    open,
    onClose,
    availableGroups,
    selectedGroups,
    loading,
    onViewDetails,
    onEditGroup,
    onAddGroup,
    onCreateNew,
    onDeleteGroup
}) {
    const [deleteConfirm, setDeleteConfirm] = useState(null);
    const [deleting, setDeleting] = useState(false);

    const handleDeleteClick = (group) => {
        setDeleteConfirm(group);
    };

    const handleConfirmDelete = async () => {
        if (!deleteConfirm || !onDeleteGroup) return;
        
        setDeleting(true);
        try {
            await onDeleteGroup(deleteConfirm.idProxyGroup);
            setDeleteConfirm(null);
        } catch (error) {
            console.error('Errore nell\'eliminazione del gruppo:', error);
        } finally {
            setDeleting(false);
        }
    };
    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    Seleziona Gruppi Whitelist
                    <Button variant="outlined" size="small" startIcon={<AddIcon />} onClick={onCreateNew}>
                        Crea Nuovo Gruppo
                    </Button>
                </Box>
            </DialogTitle>
            <DialogContent>
                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}><CircularProgress /></Box>
                ) : (
                    <List>
                        {availableGroups.filter(g => !selectedGroups.some(s => s.idProxyGroup === g.idProxyGroup)).length === 0 && (
                            <Typography sx={{ p: 2, textAlign: 'center', color: 'text.secondary' }}>
                                Nessun altro gruppo disponibile.
                            </Typography>
                        )}
                        {availableGroups.filter(g => !selectedGroups.some(s => s.idProxyGroup === g.idProxyGroup)).map(group => (
                            <ListItem key={group.idProxyGroup}>
                                <ListItemText
                                    primary={group.name}
                                    secondary={`${group.urls?.length || 0} URL - ${group.description || ''}`}
                                />
                                <ListItemSecondaryAction sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                    <Tooltip title="Visualizza dettagli">
                                        <IconButton size="small" onClick={() => onViewDetails(group.idProxyGroup)}>
                                            <ViewIcon />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Modifica gruppo">
                                        <IconButton size="small" onClick={() => onEditGroup && onEditGroup(group)}>
                                            <EditIcon />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Elimina gruppo">
                                        <IconButton size="small" color="error" onClick={() => handleDeleteClick(group)}>
                                            <DeleteIcon />
                                        </IconButton>
                                    </Tooltip>
                                    <Checkbox
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                onAddGroup(group);
                                            }
                                        }}
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                        ))}
                    </List>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Chiudi</Button>
            </DialogActions>

            {/* Dialog di conferma eliminazione */}
            <Dialog open={Boolean(deleteConfirm)} onClose={() => setDeleteConfirm(null)}>
                <DialogTitle>Conferma eliminazione</DialogTitle>
                <DialogContent>
                    <Alert severity="error">
                        <Typography variant="body2" gutterBottom>
                            <strong>Attenzione!</strong> Stai per eliminare definitivamente il gruppo <strong>"{deleteConfirm?.name}"</strong>.
                        </Typography>
                        <Typography variant="body2" gutterBottom>
                            Questa operazione rimuoverà il gruppo dall'inventario globale e da tutte le whitelist che lo utilizzano.
                        </Typography>
                        <Typography variant="body2">
                            Questa azione non può essere annullata.
                        </Typography>
                    </Alert>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDeleteConfirm(null)} disabled={deleting}>
                        Annulla
                    </Button>
                    <Button 
                        onClick={handleConfirmDelete} 
                        variant="contained" 
                        color="error"
                        disabled={deleting}
                    >
                        {deleting ? 'Eliminando...' : 'ELIMINA DEFINITIVAMENTE'}
                    </Button>
                </DialogActions>
            </Dialog>
        </Dialog>
    );
}